import { render } from "./ReceivePayments.vue?vue&type=template&id=eddd6ac4&scoped=true"
import script from "./ReceivePayments.vue?vue&type=script&lang=js"
export * from "./ReceivePayments.vue?vue&type=script&lang=js"

import "./ReceivePayments.vue?vue&type=style&index=0&id=eddd6ac4&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddd6ac4"]])

export default __exports__